import React from 'react';
import { Button as TuringUiButton } from 'turing-uiux';
import PropTypes from 'prop-types';
import forEach from 'lodash/forEach';
import './style.css';

const randomId = `turing-ui-button-${Math.floor(Math.random() * 10000)}`;

const Button = props => {
  const attributes = {};
  forEach(props, (prop, propKey) => {
    if (propKey !== 'children') {
      attributes[propKey] = prop;
    }
  });

  return (
    <TuringUiButton id={randomId} {...attributes}>
      {props.children}
    </TuringUiButton>
  );
};

Button.defaultProps = {
  children: [],
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default Button;
